import { navigate } from "gatsby";
import React from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import {
  searchSelector,
  setSearch,
} from "../../../../redux/slices/Search/search";
import GlobalSearch from "../../Search/GlobalSearch/GlobalSearch";
import { Note, StyledContainer, StyledModal } from "./OfferSearchModalHelpers";
import { IOfferSearchModalProps } from "./OfferSearchModalProps";
import { ISearchPayload } from "../../../../@types/ISearchPayload";
import { coreGetContent } from "../../../../services/core";
import { isBrowser } from "../../../../utils/helpers";
import DeepLinking from "../../DeepLinking/DeepLinking";

const OfferSearchModal: React.FC<IOfferSearchModalProps> = (props) => {
  const dispatch = useAppDispatch();
  const search = useAppSelector(searchSelector);
  const location = props.location || (isBrowser && window.location);
  const [findHotelClicked, setFindHotelClicked] = React.useState(false);
  const [isSearchingHotel, setIsSearchingHotel] = React.useState(false);

  const handleOnShow = () => {
    if (search) {
      const discountCodes = ["AAA", "AARP", "GOV", "PKG"];
      const updatedSearch = { ...search };
      if (discountCodes.includes(props.rate.code)) {
        updatedSearch.discount = props.rate.code;
        updatedSearch.groupCode = null;
        updatedSearch.promotionCode = null;
      } else {
        updatedSearch.discount = null;
        updatedSearch.groupCode = null;
        updatedSearch.promotionCode = props.rate.code;
      }
      // updatedSearch.searchString = '';
      dispatch(setSearch(updatedSearch));
    }
  };

  const handleOnHide = () => {
    if (!findHotelClicked) {
      dispatch(
        setSearch({
          ...search,
          discount: null,
          groupCode: null,
          promotionCode: null,
        })
      );
    }
    props.onHide();
  };

  const handleOnSearchSubmit = async (updatedSearch: ISearchPayload) => {
    setIsSearchingHotel(true);
    setFindHotelClicked(true); // so that we can differentiate if user clicked on find hotel or simply closed the modal
    if (updatedSearch.searchType == "hotel" && updatedSearch.searchString) {
      const hotel = await fetchHotel(updatedSearch.searchString);
      if (hotel) {
        const hotelLink = hotel.path && hotel.path.alias;
        navigate(`${hotelLink}${location.search}#rooms`);
      } else {
        navigate("/hotel-search");
      }
    }
  };

  const fetchHotel = async (hotelName: string) => {
    let fetchedHotel = null;
    const apiUrl = `/hotels?filter[status][value]=1&filter[name][value]=${hotelName}&include=brand_id`;
    const data = await coreGetContent(apiUrl);
    if (data?.data?.length) {
      fetchedHotel = data.data[0].attributes;
    }
    return fetchedHotel;
  };

  return (
    <StyledModal
      {...props}
      onShow={handleOnShow}
      onHide={handleOnHide}
      aria-label="Offer Search"
    >
      <Modal.Header className="px-3 py-2">
        <Modal.Title
          className="m-0"
          style={{
            fontSize: "18px",
            fontWeight: 700,
            fontFamily: "Roboto",
            color: "#000000",
          }}
        >
          Where to?
        </Modal.Title>
        <svg
          className="close-icon"
          tabIndex={0}
          onClick={handleOnHide}
          role="button"
          aria-label="Close sign in"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleOnHide();
              e.preventDefault();
            }
          }}
        >
          <use xlinkHref="/svg/close.svg#close"></use>
        </svg>
      </Modal.Header>
      <Modal.Body>
        <StyledContainer>
          <Row>
            <Col className="justify-content-center modalBody">
              <GlobalSearch
                location={location}
                isSearchModal
                isOfferModal={true}
                onSearchSubmit={handleOnSearchSubmit}
                submitBtnText={isSearchingHotel ? "Please wait..." : ""}
                minLOS={props.minLOS || "1"}
                minLeadDays={props.minLeadDays}
              />
              <DeepLinking location={location} />
            </Col>
          </Row>
        </StyledContainer>
      </Modal.Body>
      {/* <Modal.Footer className="justify-content-center mt-2 mb-5 pt-0">
        <Note>
          Your promo for <strong>&quot;{props.rate.name}&quot;</strong> has been
          added.
        </Note>
      </Modal.Footer> */}
    </StyledModal>
  );
};

export default OfferSearchModal;
